import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { useTranslation } from "react-i18next";

// Visually hidden but present in the DOM — readable by search engines and
// screen readers, invisible to sighted users. Standard pattern for giving a
// purely visual hero section (video, no on-screen text) a real H1, without
// changing how it looks.
const srOnlyStyle = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: 0,
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0,0,0,0)",
  whiteSpace: "nowrap",
  border: 0,
};

export default function Hero() {
  const desktopVideoRef = useRef(null);
  const mobileVideoRef = useRef(null);
  const sectionRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY;

      if (desktopVideoRef.current) {
        desktopVideoRef.current.style.transform =
          `translate(-50%, calc(-50% + ${scrolled * 0.3}px))`;
      }

      if (mobileVideoRef.current) {
        mobileVideoRef.current.style.transform =
          `translate(-50%, calc(-50% + ${scrolled * 0.3}px))`;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive:true });

    return () =>
      window.removeEventListener("scroll", handleScroll);

  }, []);


  useEffect(() => {
    gsap.fromTo(
      sectionRef.current,
      { opacity:0 },
      {
        opacity:1,
        duration:1.2,
        ease:"power2.out"
      }
    );
  }, []);


  return (
    <section ref={sectionRef} className="hero-video">

      {/* SEO/accessibility: the page's H1. Hidden visually since this
          section is video-only by design — see srOnlyStyle above. */}
      <h1 style={srOnlyStyle}>{t("hero.h1")}</h1>

      {/* Desktop */}
      <video
        ref={desktopVideoRef}
        className="hero-video__player hero-video__desktop"
        autoPlay
        muted
        loop
        playsInline
      >
        <source src="/landing1.mp4" type="video/mp4" />
      </video>


      {/* Mobile */}
      <video
        ref={mobileVideoRef}
        className="hero-video__player hero-video__mobile"
        autoPlay
        muted
        loop
        playsInline
      >
        <source src="/landing2.mp4" type="video/mp4" />
      </video>

    </section>
  );
}